import { render, staticRenderFns } from "./JoinRoomModal.vue?vue&type=template&id=293d52c2&"
import script from "./JoinRoomModal.vue?vue&type=script&lang=js&"
export * from "./JoinRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports